import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    adsbygoogle?: Record<string, unknown>[];
  }
}

/** Best-effort AdSense fill for SPA route mounts. */
export function AdSenseSlot({
  slot,
  label = 'Advertisement',
}: {
  slot: string;
  label?: string;
}) {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      /* ignore ad block / offline */
    }
  }, []);

  return (
    <div className="ad-container" aria-label={label}>
      <div className="ad-label">{label}</div>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-2497920379756999"
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
